
/* eslint-disable */
import Vue from 'vue'
import { Group } from '@/interfaces/group'
import ToolTipIcon from './ToolTipIcon.component.vue'
import GroupTeamManagement from '@/components/GroupTeamManagement.component.vue'
import draggable from 'vuedraggable'
import GroupsComponent from './Groups.component.vue'
import { functions } from '@/firebase/functions'
import { showSnackbar } from '@/globalActions'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

// @vuese
export default Vue.extend({
  name: 'GroupManagement',
  props: {
    competition: {
      type: Object,
      default: function () {
        return {
          visible_on_web: false
        }
      }
    }
  },
  components: {
    GroupTeamManagement,
    ToolTipIcon,
    draggable
  },
  data () {
    return {
      group: {
        competitionId: this.competition.id,
        visible_on_web: false,
        order: 0,
        cup: false
      } as Group,
      drag: false,
      editDialog: false,
      editSaving: false,
      editForm: {
        name: '',
        name_on_web: '',
        ageGroup: '',
        order: 0,
        open: false,
        visible_on_web: false,
        spiideoEnabled: false,
        disabled: false
      },
      spiideo: {
        dialog: false,
        syncing: false,
        loadingSeries: false,
        loadingCompetitions: false,
        loadingStages: false,
        stagesLoaded: false,
        seriesLoaded: false,
        competitionAccountId: null as string | null,
        seriesId: null as string | null,
        competitionId: null as string | null,
        competitionName: null as string | null,
        pickedCompetitionId: null as string | null,
        series: [] as Array<{ id: string; name: string; shortName?: string }>,
        competitions: [] as Array<{ id: string; name: string; startTime?: string; stopTime?: string }>,
        stages: [] as Array<{ id: string; name: string }>
      }
    }
  },
  computed: {
    groups: {
        get() {
          return this.$store.getters['GroupModule/filterByCompetition'](this.competition.id)
        },
        set(value: any) {
          value.forEach((group: any, index: any) => {
          const id = group.id;
          this.$store.dispatch('GroupModule/set', {
            id,
            order: index
          }).catch((error: any) => {
            console.log(error)
          })
        })
      }
    },
    spiideoCompetitionIdTrimmed (): string {
      return String(this.spiideo.competitionId || '').trim()
    }
  },
  mounted () {
    this.$store.dispatch('GroupModule/fetchAndAdd', { where: [['competitionId', '==', this.competition.id]] })
  },
  methods: {
    prepareEditCompetition () {
      this.editForm = {
        name: this.competition.name || '',
        name_on_web: this.competition.name_on_web || '',
        ageGroup: this.competition.ageGroup || '',
        order: this.competition.order || 0,
        open: !!this.competition.open,
        visible_on_web: !!this.competition.visible_on_web,
        spiideoEnabled: !!this.competition.spiideoEnabled,
        disabled: !!this.competition.disabled
      }
    },
    async saveCompetitionEdit () {
      if (!this.competition.id || this.editSaving) {
        return
      }
      this.editSaving = true
      try {
        const payload = {
          id: this.competition.id,
          name: this.editForm.name,
          name_on_web: this.editForm.name_on_web,
          ageGroup: this.editForm.ageGroup,
          order: this.editForm.order,
          open: !!this.editForm.open,
          visible_on_web: !!this.editForm.visible_on_web,
          spiideoEnabled: !!this.editForm.spiideoEnabled,
          disabled: !!this.editForm.disabled
        }
        Object.keys(payload).forEach((key) => {
          if (key === 'id') {
            return
          }
          this.$set(this.competition, key, (payload as any)[key])
        })
        await this.$store.dispatch('CompetitonsModule/patch', payload)
        this.editDialog = false
      } catch (err) {
        console.error('saveCompetitionEdit', err)
        showSnackbar(
          (err && (err as Error).message) || 'Save failed',
          { duration: 5000 }
        )
      } finally {
        this.editSaving = false
      }
    },
    async openSpiideoSync () {
      if (!this.competition.spiideoEnabled) {
        showSnackbar(this.$t('spiideo-enabled-required') as string, { duration: 5000 })
        return
      }
      this.spiideo.dialog = true
      this.spiideo.seriesId = this.competition.spiideoCompetitionSeriesId || null
      this.spiideo.competitionId = this.competition.spiideoCompetitionId || null
      this.spiideo.competitionName = this.competition.spiideoCompetitionName || null
      this.spiideo.pickedCompetitionId = this.competition.spiideoCompetitionId || null
      await this.loadSpiideoCompetitionAccountId()
      // List load is optional — manual competition ID is enough to sync.
      if (this.spiideo.series.length === 0) {
        this.loadSpiideoSeries()
      } else if (this.spiideo.seriesId) {
        this.loadSpiideoCompetitions(this.spiideo.seriesId)
      }
    },
    async loadSpiideoCompetitionAccountId () {
      try {
        const snap = await firebase.firestore()
          .collection('settings')
          .doc('spiideo')
          .get()
        const data = snap.exists ? snap.data() || {} : {}
        this.spiideo.competitionAccountId =
          data.competition_account_id ||
          data.competitionAccountId ||
          null
      } catch (err) {
        console.error('loadSpiideoCompetitionAccountId', err)
        this.spiideo.competitionAccountId = null
      }
    },
    async loadSpiideoSeries () {
      this.spiideo.loadingSeries = true
      try {
        const listSeries = functions.httpsCallable('spiideoListCompetitionSeriesV2')
        const result: any = await listSeries({})
        this.spiideo.series = (result && result.data && result.data.series) || []
        this.spiideo.seriesLoaded = true
        if (this.spiideo.seriesId) {
          await this.loadSpiideoCompetitions(this.spiideo.seriesId)
        }
      } catch (err: any) {
        console.error('spiideoListCompetitionSeriesV2', err)
        this.spiideo.seriesLoaded = true
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
      } finally {
        this.spiideo.loadingSeries = false
      }
    },
    async onSpiideoSeriesChange (seriesId: string) {
      this.spiideo.pickedCompetitionId = null
      this.spiideo.competitions = []
      if (seriesId) {
        await this.loadSpiideoCompetitions(seriesId)
      }
    },
    onSpiideoCompetitionPicked (competitionId: string) {
      if (!competitionId) {
        return
      }
      this.spiideo.competitionId = competitionId
      const selected = this.spiideo.competitions.find((c) => c.id === competitionId)
      if (selected && selected.name) {
        this.spiideo.competitionName = selected.name
      }
    },
    async loadSpiideoCompetitions (seriesId: string) {
      this.spiideo.loadingCompetitions = true
      try {
        const listCompetitions = functions.httpsCallable('spiideoListCompetitionsV2')
        const result: any = await listCompetitions({ competitionSeriesId: seriesId })
        this.spiideo.competitions = (result && result.data && result.data.competitions) || []
      } catch (err: any) {
        console.error('spiideoListCompetitionsV2', err)
      } finally {
        this.spiideo.loadingCompetitions = false
      }
    },
    async ensureSpiideoStagesLoaded () {
      if (!this.competition.spiideoCompetitionId || this.spiideo.stagesLoaded || this.spiideo.loadingStages) {
        return
      }
      this.spiideo.loadingStages = true
      try {
        const listStages = functions.httpsCallable('spiideoListStagesV2')
        const result: any = await listStages({
          competitionId: this.competition.spiideoCompetitionId
        })
        const stages = (result && result.data && result.data.stages) || []
        this.spiideo.stages = stages.map((s: { id: string; name?: string }) => ({
          id: s.id,
          name: s.name || s.id
        }))
        this.spiideo.stagesLoaded = true
      } catch (err: any) {
        console.error('spiideoListStagesV2', err)
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-stages-load-failed') as string),
          { duration: 5000 }
        )
      } finally {
        this.spiideo.loadingStages = false
      }
    },
    async syncCompetitionToSpiideo () {
      const spiideoCompetitionId = this.spiideoCompetitionIdTrimmed
      if (!spiideoCompetitionId) {
        showSnackbar(this.$t('spiideo-competition-required') as string, { duration: 5000 })
        return
      }
      const selected = this.spiideo.competitions.find(
        (c) => c.id === spiideoCompetitionId
      )
      const spiideoCompetitionName =
        String(this.spiideo.competitionName || '').trim() ||
        (selected && selected.name) ||
        spiideoCompetitionId
      this.spiideo.syncing = true
      try {
        const syncCompetition = functions.httpsCallable('spiideoSyncCompetitionV2')
        const result: any = await syncCompetition({
          competitionId: this.competition.id,
          spiideoCompetitionId,
          spiideoCompetitionSeriesId: this.spiideo.seriesId || undefined,
          spiideoCompetitionName
        })
        const data = (result && result.data) || {}
        await this.$store.dispatch('CompetitonsModule/patch', {
          id: this.competition.id,
          spiideoCompetitionId: data.spiideoCompetitionId,
          spiideoCompetitionSeriesId: data.spiideoCompetitionSeriesId,
          spiideoCompetitionName: data.spiideoCompetitionName
        })
        this.$set(this.competition, 'spiideoCompetitionId', data.spiideoCompetitionId)
        this.$set(this.competition, 'spiideoCompetitionSeriesId', data.spiideoCompetitionSeriesId)
        this.$set(this.competition, 'spiideoCompetitionName', data.spiideoCompetitionName)
        this.spiideo.stages = []
        this.spiideo.stagesLoaded = false
        this.spiideo.dialog = false
        showSnackbar(
          this.$t('spiideo-competition-sync-success', {
            enrolled: data.enrolled || 0,
            created: data.createdTeams || 0,
            skipped: (data.skipped && data.skipped.length) || 0
          }) as string
        )
      } catch (err: any) {
        console.error('spiideoSyncCompetitionV2', err)
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
      } finally {
        this.spiideo.syncing = false
      }
    },
    updateGroup (group: Group, dialog: { value: boolean }) {
      const id = group.id
      this.$store.dispatch('GroupModule/set', {
        id,
        competitionId: group.competitionId,
        gender: group.gender,
        name: group.name,
        name_on_web: ('name_on_web' in group) ? group.name_on_web : null,
        visible_on_web: group.visible_on_web,
        disabled: ('disabled' in group) ? group.disabled : false,
        cup: ('cup' in group) ? group.cup : false,
        spiideo_stage_id: group.spiideo_stage_id || null
      }).then(() => {
        dialog.value = !dialog.value
      }).catch((error: any) => {
        console.log(error)
      })
    },
    insertGroup (dialog: { value: boolean }) {
      this.group.order = this.groups.length
      this.$store.dispatch('GroupModule/insert', this.group).then(() => {
        delete this.group.id
      })
      dialog.value = false
    }
  }
})
